import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { Routes } from '@huge-monorepo/portal/config';
import { GoToMenuComponent } from '../go-to-menu/go-to-menu.component';
import { SettingsMenuComponent } from '../settings-menu/settings-menu.component';
import { ChangeSessionModalComponent } from '../change-session-modal/change-session-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedGenericSingletonService } from '@huge-monorepo/shared/services';
import { ICustomerGenericService, IHIPGenericService } from '@huge-monorepo/shared/interfaces';
import { AccountManagementMenuComponent } from '../account-management-menu/account-management-menu.component';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss'],
})
export class TopNavbarComponent implements OnInit, OnDestroy {
  // add local reference to enum for html availability
  ScreenSize = ScreenSize;
  appVersion: string;
  navRoutes: any[] = [];
  @Output() showSplitpane = new EventEmitter();

  groupName: string | null;
  hasReporting = false;
  authSubscription: Subscription;
  path = this.sharedGenericService.getPath();
  changeSession: boolean = false;
  settingsOpen: boolean;
  accountOpen: boolean;
  changeSessionOpen: boolean;
  lightMode = this.sharedGenericService.getIsLightMode();

  constructor(
    public titleService: TitleService,
    public navigationService: NavigationService,
    public layoutService: LayoutService,
    private endpoints: Endpoints,
    private router: Router,
    private routes: Routes,
    private auth: UserRightsService,
    private dialog: MatDialog,
    private sharedGenericService: SharedGenericSingletonService< ICustomerGenericService | IHIPGenericService >,
  ) {
    this.groupName = auth.GetGroupName();
  }
  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }

  ngOnInit() {
    this.appVersion = this.endpoints.APP_VERSION;
    this.hasReporting = this.auth.HasReportingRole();
    this.authSubscription = this.auth.GetUser()?.subscribe((user) => {
      if (user.isObfuscated) {
        this.groupName = 'Demo';
      } else {
        this.groupName = user.GroupName;
      }
    });
  }

  async openChangeSessionModal(ev: any) {
    this.changeSessionOpen = true;
    this.changeSession = !this.changeSession;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    var width = 382;
    const dialogRef = this.dialog.open(ChangeSessionModalComponent, {
      position: {top: "60px", right: "40px"},
      width: width + "px",
      height: "fit-content",
      data: {groupName: this.groupName},
      panelClass: "nav-dialog",
    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.style.overflow = ''; // Restore body scroll
      document.documentElement.style.overflow = ''; // Restore html scroll
      this.changeSessionOpen = false;
    });
  }

  async openSettingsModal(ev: any) {
    this.settingsOpen = true;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    var width = 232;
    const dialogRef = this.dialog.open(SettingsMenuComponent, {
      position: {top: "60px", right: "20px"},
      width: width + "px",
      panelClass: "nav-dialog",
    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.style.overflow = ''; // Restore body scroll
      document.documentElement.style.overflow = ''; // Restore html scroll
      this.settingsOpen = false;
    });
  }

  async openAccountModal(ev: any) {
    this.accountOpen = true;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    var width = 232;
    const dialogRef = this.dialog.open(AccountManagementMenuComponent, {
      position: {top: "60px", right: "20px"},
      width: width + "px",
      panelClass: "nav-dialog",
    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.style.overflow = ''; // Restore body scroll
      document.documentElement.style.overflow = ''; // Restore html scroll
      this.accountOpen = false;
    });
  }

  goToNavigation() {
    this.router.navigateByUrl(this.routes.Navigate);
  }

  goToSettings() {
    this.router.navigateByUrl(this.routes.Settings);
  }

  toggleSplitpane() {
    this.showSplitpane.emit(!this.navigationService.IsSideNavOpen());
  }

  changeRoute(url: any) {
    this.navigationService.deactivateMenuItems();
    this.navigationService.Navigate(url);
  }
}
